<template>
	<div class="container">
		<div class="meditation-info" v-show="showContent">
			<img :src="meditation.bg_url" alt="" class="meditation-banner">
			<div style="position: absolute;top: 100px;width: 100%;padding: 15px;">
				<div>
					<h2>{{meditation.title}}</h2>
				</div>
				<div style="display: flex;">
					<div style="padding: 5px;background-color: #9e9e9e;color: #fff;margin-right: 10px;font-size: 10px;border-radius: 4px;"
						v-for="(item,index) in meditation.keywords" :key="index">
						{{item}}
					</div>
				</div>
			</div>
			<div class="info-container">
				<div class="info-main">
					<div class="meditation-name">简介</div>
					<div class="meditation-time">
						<div class="time-text">时长</div>
						<div class="time">{{parseInt(meditation.audio_duration/60)}}分钟</div>
					</div>
					<div class="info-text">{{meditation.intro}}</div>
					<div class="meditation-name">学习建议</div>
					<div
						style="display: flex;align-items: center;justify-content: space-between;text-align: center;flex-wrap: wrap;">
						<div v-for="(item,index) in meditation.advices" :key="index"
							style="background-color: #dfdfdf;border-radius: 10px;padding: 10px;margin-bottom: 15px;">
							<div
								style="display: flex;align-items: center;justify-content: space-between;text-align: center;flex-direction: row;color: #a1a1a1;">
								<img width="15" height="15" :src="item.icon_url" /> {{item.name}}
							</div>
							<div>{{item.describe}}</div>
						</div>
					</div>
					<div class="start-box">
						<div class="start" @click="start">马上参与</div>
					</div>
				</div>
			</div>
		</div>
		<div class="meditation-content" v-show="!showContent">
			<div class="pic-box">
				<img :src="meditation.bg_url" alt="" class="meditation-icn">
			</div>
			<div class="train-name">{{meditation.title}}</div>
<!-- 			<div class="step">
				<div class="step-line" :style="{ width: press + '%' }"></div>
				<div class="step-dot" :style="{ left: (press / 100) * 300 - 6 + 'px' }"></div>
			</div> -->
			<div style="padding: 20px 50px;">
				<van-slider v-model="press" @change="onChange" />
			</div>
			<div style="text-align: center;">{{nowTime||"00:00"}}/{{allTime}}</div>
			<div class="control">
				<img src="../assets/bian/play.png" alt="" class="play" v-show="nowControl == 'play'" @click="play" />
				<img src="../assets/bian/pause.png" alt="" class="pause" v-show="nowControl == 'pause'"
					@click="pause" />
			</div>
			<audio ref="audio" :src="audioUrl" type="audio/mp3" controls="controls" @timeupdate="update"
				@ended="end" class="music" id="m1"></audio>
		</div>
		<div class="out-modal" v-show="showOut">
			<div class="out">
				<div class="out-title">退出将无法保存</div>
				<div class="out-content">中途退出后，训练记录无法保存，建议您完成训练</div>
				<div class="btns">
					<div class="cancel" @click="out">退出</div>
					<div class="sure" @click="showOut=false">继续训练</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		Slider
	} from 'vant';
	import {
		meditation_details,
		ali_getVideo,
		// add_train
	} from '../api/adjust'
	import {
		service_resource,add_train
	} from '../api/server'
	export default {
		components: {
			[Slider.name]: Slider,
		},
		data() {
			return {
				showOut: false,
				showContent: true,
				loginPhone: '',
				trainName: '',
				videoId: '',
				trainDes: '',
				allTime: '',
				allTimeStr: '',
				m1: null,
				trainSrc: null,
				press: 0,
				nowControl: 'play',
				isFirst: true,
				nowTime: "",
				startTime: '',
				endTime: '',
				meditation: {},
				audioUrl: "",
				loginImei:	'',
				quit:false
			};
		},
		computed: {

		},
		methods: {
			onChange(value) {
				// console.log('当前值：' + value);
				this.$refs.audio.currentTime = this.meditation.audio_duration * value / 100;
			},
			start() {
				// this.all();
				this.showContent = false;
			},
			out() {
				// this.goOut()
				this.quit = true;
				this.$router.replace('/service')
			},
			articleDetails() {
				let data = {
					audio_id: parseInt(this.$route.query.audio_id)
				}
				service_resource(JSON.stringify(data), 'heartide.bixin.audio.details').then(res => {
					if (res.code == '0') {
						let reslist = JSON.parse(res.data)
						this.meditation = reslist
						this.trainName = reslist.title;
						console.log(this.meditation);
					}
				}).catch(e => {
					console.log(e);
				})
				service_resource(JSON.stringify({
					audio_id: parseInt(this.$route.query.audio_id)
				}), 'heartide.bixin.audio.playurl').then(res => {
					if (res.code == '0') {
						let reslist = JSON.parse(res.data)
						this.audioUrl = reslist.audio_play_url
						// console.log(this.meditation);
						let time = reslist.audio_duration; //获取总播放时间
						this.allTimeStr = time;
						if (!time) {
							time = 0;
						}
						let minutes = parseInt(time / 59);
						if (minutes < 10) {
							minutes = "0" + minutes;
						}
						let second = Math.round(time % 59);
						if (second < 10) {
							second = "0" + second;
						}
						let allTime = minutes + ":" + second;
						this.allTime = allTime;
					}
				}).catch(e => {
					console.log(e);
				})
			},
			// all() {
				// if(!this.$refs.audio) return;
				// let time = this.$refs.audio.duration; //获取总播放时间
				// this.$toast(time);
				// this.allTimeStr = time;
				// if (!time) {
				// 	time = 0;
				// }
				// let minutes = parseInt(time / 59);
				// if (minutes < 10) {
				// 	minutes = "0" + minutes;
				// }
				// let second = Math.round(time % 59);
				// if (second < 10) {
				// 	second = "0" + second;
				// }
				// let allTime = minutes + ":" + second;
				// this.allTime = allTime;
			// },
			play() {
				if (this.isFirst) {
					let date = new Date();
					let time = parseInt(date.getTime() / 1000)
					this.startTime = time;
				}
				this.isFirst = false;
				// this.$refs.audio.play();
				this.$refs.audio.play();
				this.nowControl = "pause";
			},
			pause() {
				this.$refs.audio.pause();
				this.nowControl = "play";
			},
			update() {
				if(!this.$refs.audio) return;
				let time = this.$refs.audio.duration; //获取总播放时间      
				let nowTime = this.$refs.audio.currentTime; //获取播放进度            
				let press = (nowTime / time) * 100;
				this.press = press;
				// let nowTimeNum = this.meditation.audio_duration * nowTime / 1000;
				let nowTimeNum = nowTime;
				let minutes = parseInt(nowTimeNum / 59);
				if (minutes < 10) {
					minutes = "0" + minutes;
				}
				let second = Math.round(nowTimeNum % 59);
				if (second < 10) {
					second = "0" + second;
				}
				this.nowTime = minutes + ":" + second;
			},
			end() {
				this.$refs.audio.pause();
				this.nowControl = "play";
				this.nowTime = "";
				let date = new Date();
				let time = parseInt(date.getTime() / 1000)
				this.endTime = time;
				add_train(this.loginPhone,this.loginImei, this.startTime, this.endTime, 'train', this.trainName).then(res => {
					if (res.status == 200) {
						// this.$router.push({
						// 	path: '/train-report',
						// 	query: {
						// 		id: res.data.trainData[0].id
						// 	}
						// })
						this.$router.push({
							path: '/meditation-report',
							query: {
								id: res.data.trainData[0].id,
								newTrain:1
							}
						})
					}
				})
			}
		},
		created() {
			let phone = localStorage.getItem('phone')
			this.loginPhone = phone;
			let imei = localStorage.getItem('imei')
			this.loginImei = imei;
			// this.meditation = this.$route.query
			// console.log(this.meditation);
			this.articleDetails()
		},
		beforeRouteLeave(to, from, next) {
			console.log("beforeRouteLeave");
			if (this.nowTime && !this.quit) {
				// if(this.testNum>1){
				this.showOut = true
				// this.goOut=next
			} else {
				next()
			}
		}
	};
</script>
<style lang='less' scoped>
	.container {
		min-height: 100vh;
		background-image: linear-gradient(to bottom, #E9FAF5, #F4FFF8);
	}

	.meditation-info {
		position: relative;
		height: 100vh;
	}

	.meditation-banner {
		width: 100%;
		position: relative;
	}

	.info-container {
		position: absolute;
		bottom: 0px;
		left: 0px;
		background-color: #fff;
		width: 100%;
		height: 68vh;
		border-radius: 40px 40px 0px 0px;
	}

	.info-main {
		padding: 20px 16px;
	}

	.meditation-name {
		line-height: 40px;
		font-size: 24px;
		color: #000000;
		font-weight: bold;
		padding-bottom: 10px;
	}

	.meditation-time {
		height: 48px;
		display: flex;
		justify-content: space-between;
		background-color: #F6F7FB;
		padding: 0px 16px;
	}

	.time-text {
		height: 48px;
		line-height: 48px;
		font-size: 14px;
		color: #969696;
		font-weight: 500;
	}

	.time {
		height: 48px;
		line-height: 48px;
		font-size: 14px;
		color: #333;
		font-weight: bold;
	}

	.info-text {
		padding-top: 27px;
		line-height: 24px;
		color: #969696;
		font-weight: 500;
	}

	.start-box {
		position: fixed;
		left: 0px;
		bottom: 0px;
		width: 100%;
		z-index: 10;
		padding-bottom: 20px;
		background-color: #fff;
	}

	.start {
		height: 52px;
		border-radius: 26px;
		background-image: linear-gradient(to right, #00C8BD, #40D2DA);
		text-align: center;
		line-height: 52px;
		color: #fff;
		font-size: 16px;
		font-weight: 500;
		margin: 0px 15px;
	}

	.music {
		display: none;
	}

	.meditation-content {
		padding-top: 140px;
	}

	.pic-box {
		width: 240px;
		height: 240px;
		margin: 0px auto 30px;
		border-radius: 50%;
		background-image: linear-gradient(to right bottom, #262324, #797879);
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.meditation-icn {
		display: block;
		height: 180px;
		width: 180px;
		border-radius: 50%;
	}

	.train-name {
		height: 40px;
		line-height: 40px;
		text-align: center;
		color: #2E2E2E;
		font-weight: bold;
		font-size: 24px;
		padding-bottom: 90px;
	}

	.step {
		width: 300px;
		margin: 0 auto;
		height: 5px;
		background-color: #afc0c6;
		border-radius: 2px;
		position: relative;
	}

	.step-line {
		height: 5px;
		position: absolute;
		left: 0px;
		top: 0px;
		background-color: #000;
		width: 0px;
	}

	.step-dot {
		height: 11px;
		width: 11px;
		border-radius: 50%;
		background-color: #000;
		position: absolute;
		left: -6px;
		top: -3px;
	}

	.control {
		height: 60px;
		margin-top: 40px;
	}

	.play {
		display: block;
		height: 60px;
		width: 60px;
		border-radius: 50%;
		margin: 0 auto;
	}

	.pause {
		display: block;
		height: 60px;
		width: 60px;
		border-radius: 50%;
		margin: 0 auto;
	}

	.out-modal {
		position: fixed;
		left: 0px;
		top: 0px;
		background-color: rgba(0, 0, 0, 0.2);
		z-index: 10;
		width: 100%;
		height: 100%;
	}

	.out {
		width: 210px;
		padding: 30px;
		background-color: #fff;
		border-radius: 10px;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}

	.out-title {
		height: 20px;
		line-height: 20px;
		font-size: 20px;
		font-weight: 500;
		color: #333;
		margin-bottom: 30px;
		text-align: center;
	}

	.out-content {
		line-height: 20px;
		font-size: 14px;
		color: #333;
		margin-bottom: 30px;
		text-align: center;
	}

	.btns {
		height: 48px;
		display: flex;
		justify-content: space-between;
	}

	.cancel {
		height: 48px;
		width: 48%;
		border-radius: 24px;
		line-height: 48px;
		text-align: center;
		background-color: #F2F6F6;
		font-size: 16px;
		font-weight: 500;
		color: #333;
	}

	.sure {
		height: 48px;
		width: 48%;
		border-radius: 24px;
		line-height: 48px;
		text-align: center;
		background-color: #01D6D6;
		font-size: 16px;
		font-weight: 500;
		color: #fff;
	}
</style>